import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

const defaultMutationFn = async ({ queryKey }, data:any) => {
    // const { mutationFn = null, ...data } = params;
    const { data: response } = await authenticatedApi.put(`/${queryKey[0]}/${queryKey[1]}`, data);
    return response;//data.hasOwnProperty('data') ? data.data : data;
}

export function useUpdate(queryParams/*, params:any = null*/) {
    const queryClient = useQueryClient();
    // const fn = queryParams.mutationFn || defaultMutationFn;

    const { queryKey } = queryParams;

    return useMutation({
        // ...queryParams,
        // mutationFn: fn,// fn.bind(null, queryParams, params),//fn(queryParams, params),
        mutationFn: async (data:any) => {
            // const { mutationFn = null, ...data } = params;
            const { data: response } = await authenticatedApi.put(`/${queryKey[0]}/${queryKey[1]}`, data);
            return response;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            /*
            let { queryKey } = queryParams;
            if(params.hasOwnProperty('id')) {
                queryKey.push(params.id);
            }
            */
            // console.log(queryKey);
            queryClient.invalidateQueries({ queryKey: [queryKey[0]] }); // leave this here
            queryClient.invalidateQueries({ queryKey });
            // todo: invalidate searchselect_$ too?
            // queryClient.invalidateQueries({ queryKey: ['reminders'] })
        },
    });
}
